import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderSubjectModuleWise = new Subject<Boolean>();
  loaderStateModuleWise = this.loaderSubjectModuleWise.asObservable();

  private loaderSubject = new Subject<Boolean>();
  loaderState = this.loaderSubject.asObservable();
  private loaderheaderSubject = new Subject<Boolean>();
  loaderheaderState = this.loaderheaderSubject.asObservable();
  private handleSpinnerSubject = new BehaviorSubject<boolean>(false);
  hideSpinner = this.handleSpinnerSubject.asObservable();
  private handlePolicySpinnerSubject = new BehaviorSubject<boolean>(false);
  hidePolicySpinner = this.handlePolicySpinnerSubject.asObservable();
  constructor() { }
  showSpinnerModuleWise() {
    this.loaderSubjectModuleWise.next(<Boolean>(true));
  }
  hideSpinnerModuleWise() {
    this.loaderSubjectModuleWise.next(<Boolean>(false));
  }

  show() {
    this.loaderSubject.next(<Boolean>(true));
  }
  hide() {
    this.loaderSubject.next(<Boolean>(false));
  }
  showLoader() {
    this.loaderheaderSubject.next(<Boolean>(true));
  }
  hideLoader() {
    this.loaderheaderSubject.next(<Boolean>(false));
  }
  handleSpinner(val: boolean) {
    this.handleSpinnerSubject.next(val);
  }
  handlePolicySpinner(val: boolean) {
    this.handlePolicySpinnerSubject.next(val);
  }
}
